export class HelpCenterEndpoints {
  helpCenterVisitorToken(): string {
    return "/horde/v1/auth/gitbook/visitor-token";
  }
}
